<template>
  <div class="login-container">
    <div class="login-wrapper" v-cloak>
      <div class="weixin-scan" v-show="imgShow">
        <template v-if="loginWay===1">
          <p class="tips">{{loginWithScan.weixinInfo?'请确认登录':'请使用微信扫码登录'}}</p>
          <div class="qrcode">
            <img v-if="loginWithScan.weixinInfo" :src="loginWithScan.weixinInfo.headimgurl">
            <img v-if="!loginWithScan.weixinInfo" :src="`data:image/jpeg;base64,${loginWithScan.qrcodeBase64}`">
          </div>
        </template>
        <template v-if="loginWay===2">
          <p class="tips2">请使用账号密码登录</p>
          <el-form class="input" :model="loginWithNumber" :rules="rules" ref="loginWithNumber" label-width="0px">
            <el-form-item prop="email">
              <el-input v-model="loginWithNumber.email" placeholder="邮箱" clearable></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input v-model="loginWithNumber.phone" placeholder="手机号" clearable></el-input>
            </el-form-item>
            <el-form-item prop="sms_code">
              <el-col :span="12">
                <el-input v-model="loginWithNumber.sms_code" placeholder="短信验证码" clearable></el-input>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-button type="primary" :disabled="timer!==null" @click="getSmsCode" style="width:100%">
                  验证码
                  {{timer!==null?'（'+sencond+'）':''}}
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width:100%" @click="submit">登录</el-button>
            </el-form-item>
          </el-form>
        </template>
        <!-- <span class="change-login-ways cursor-pointer" @click="loginWayChange">
          <i class="el-icon-sort"></i>
        </span> -->
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { setToken, setStorage, getStorage } from '@/utils/auth'
export default {
  name: 'login',
  data () {
    let validateEamil = (rule, value, callback) => {
      let reg = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*.[a-zA-Z0-9]{2,6}$')
      if (value === '') {
        callback(new Error('请输入邮箱!'))
      } else if (!reg.test(value)) {
        callback(new Error('邮箱格式错误!'))
      } else {
        callback()
      }
    }

    let validatePhone = (rule, value, callback) => {
      let reg = new RegExp('^((1[0-9]))\\d{9}$')
      if (value === '') {
        callback(new Error('请输入手机号!'))
      } else if (!reg.test(value)) {
        callback(new Error('手机号格式错误!'))
      } else {
        callback()
      }
    }

    return {
      loginWay: 2,
      loginWithScan: {
        qrcodeBase64: '',
        loginid: '',
        weixinInfo: ''
      },
      loginWithNumber: {
        email: '',
        phone: '',
        sms_code: ''
      },
      sencond: 60,
      rules: {
        email: [
          { validator: validateEamil, trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ]
      },
      tenantList: [],
      token: '',
      timer: null,
      imgShow: true
    }
  },
  watch: {
    loginWay () {
      this.loginWay === 1 ? this.loginWay1() : this.loginWay2()
    }
  },
  created () {
    this.loginWithNumber.email = getStorage('email') || ''
    this.loginWithNumber.phone = getStorage('phone') || ''
  },
  methods: {
    loginWay1 () {
      clearInterval(this.timer)
      this.timer = null
      const qrcodeRequest = request({
        url: 'login/qrcode',
        method: 'get'
      })
      const login = new Promise((resolve, reject) => {
        qrcodeRequest.then(res => {
          this.$myLoading.hide()
          this.imgShow = true
          const data = res.data
          this.loginWithScan.qrcodeBase64 = data.src
          this.loginWithScan.loginid = data.loginid
          resolve(data.loginid)
        }).catch(err => {
          reject(err)
        })
      })
      login.then((loginid) => {
        this.timer = setInterval(() => {
          request({
            url: `login/${loginid}`,
            method: 'get'
          }, false).then(res => {
            // admin扫码
            if (res.data.scanned_by) {
              this.loginWithScan.weixinInfo = res.data.scanned_by
            }
            // admin 确认登录
            if (res.data.token) {
              clearInterval(this.timer)
              setToken(res.data.token)
              this.$store.dispatch('GetAdminInfo').then(res => {
                this.$router.replace({ name: this.$store.getters.userRoutes[0].name })
              })
            }
          }).catch(() => {
            clearInterval(this.timer)
          })
        }, 1000)
      })
    },
    loginWay2 () {
      clearInterval(this.timer)
      this.timer = null
    },
    submit () {
      this.$refs['loginWithNumber'].validate(valid => {
        if (valid) {
          this.loginIn()
        } else {
          return false
        }
      })
    },
    loginIn () {
      if (this.loginWithNumber.sms_code === '') {
        this.$message.error('请输入短信验证码!')
        return false
      }
      this.$myLoading.show()
      request({
        url: 'login/phone-login',
        method: 'post',
        data: this.loginWithNumber
      }).then(res => {
        this.$myLoading.hide()
        setToken(res.data.token)
        this.$store.dispatch('GetAdminInfo').then(res => {
          setStorage('email', this.loginWithNumber.email)
          setStorage('phone', this.loginWithNumber.phone)
          this.$router.replace({ name: this.$store.getters.userRoutes[0].name })
        })
      })
    },
    getSmsCode () {
      this.$refs['loginWithNumber'].validate((valid, error) => {
        if (error.email && error.phone) {
          this.$message({
            message: '获取验证码之前请确保邮箱和手机号已正确输入!',
            type: 'error',
            duration: 5 * 1000
          })
          return false
        }
        this.sencond = 60
        let sendData = {
          email: this.loginWithNumber.email,
          phone: this.loginWithNumber.phone
        }
        this.$myLoading.show()
        request({
          url: 'login/sms-code',
          method: 'post',
          data: sendData
        }).then(res => {
          this.$myLoading.hide()
          this.$message.success('验证码已发送!')
          this.timer = setInterval(_ => {
            if (this.sencond === 0) {
              clearInterval(this.timer)
              this.timer = null
            } else {
              this.sencond--
            }
          }, 1000)
        })
      })
    },
    loginWayChange () {
      this.loginWay = this.loginWay === 1 ? 2 : 1
    }
  }
}
</script>
<style lang="less" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background: url(https://console.shop.flyingblind.cn/static/img/bg.ae3b60a.jpg) no-repeat;
  background-size: cover;
  .login-wrapper {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    .weixin-scan {
      width: 320px;
      height: 350px;
      background: #ffffff;
      margin: 0 auto;
      margin-top: 230px;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      p.tips {
        font-size: 20px;
      }
      .qrcode {
        width: 190px;
        height: 190px;
        padding: 10px;
        margin-top: 20px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .tips2 {
        font-size: 20px;
      }
      .input {
        margin: 0 auto;
        margin-top: 20px;
        width: 85%;
      }
      .change-login-ways {
        position: absolute;
        top: 10px;
        right: 0;
        background-color: #008000;
        color: #ffffff;
        transform: rotate(90deg);
        padding: 4px;
      }
    }
  }
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue